require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-35-adding-company-holidays.json") })
        }
      }, "path---article-35-adding-company-holidays");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-35-adding-company-holidays!./.cache/json/article-35-adding-company-holidays.json
// module id = 545
// module chunks = 231608221292675